import { Dropdown } from 'react-bootstrap';
import * as React from 'react';
import { useMenuBalanceContext } from 'moduleBase/modules/menu-balance/hooks/use-menu-balance-context';
import { DropdownToggle } from 'moduleBase/modules/menu-balance/components/DropdownToggle';
import { DropdownMenu } from 'moduleBase/modules/menu-balance/components/DropdownMenu';

var MenuBalanceDropdown = function MenuBalanceDropdown() {
  var _useMenuBalanceContex = useMenuBalanceContext(),
      isOpen = _useMenuBalanceContex.isOpen,
      show = _useMenuBalanceContex.show,
      hide = _useMenuBalanceContex.hide;

  return /*#__PURE__*/React.createElement(Dropdown, {
    className: "balance-dropdown",
    show: isOpen,
    onToggle: function onToggle(isOpenLocal, event, metadata) {
      if (metadata.source === 'rootClose') {
        hide();
      } else {
        show();
      }
    }
  }, /*#__PURE__*/React.createElement(DropdownToggle, {
    isOpen: isOpen
  }), /*#__PURE__*/React.createElement(DropdownMenu, null));
};

export { MenuBalanceDropdown };